import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './safraForm';
import imagemSoLogo from '../assets/images/sologo.png';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

import {
	setModoTela, initForm, salvar, excluir, getLista, getListaProdutor, getListaArea, getListaEspecie, imprimir
} from './safraActions';

class Safra extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista();
		this.props.setModoTela('lista');
		this.props.getListaProdutor();
		this.props.getListaArea();
		this.props.getListaEspecie();
    }

    render() {
        return (
            <div>

				{this.props.aguardando ? (
					<div class='modal fade show' id='modal-overlay' style={{ display: 'block', paddingRight: 15 }} aria-modal='true' role='dialog'>
						<div class='modal-dialog'>
							<div class='overlay'>
								<div style={{ marginLeft: '50%', marginRight: '50%' }}>
									<img src={imagemSoLogo} style={{ height: 40, width: 40, marginBottom: -76, marginLeft: 8 }} />
								</div>
								<i class='fas fa-4x fa-spinner fa-spin' style={{ marginLeft: '50%', marginRight: '50%' }}></i>
							</div>
						</div>
					</div>
				) : null}

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
					{this.props.modoTela == 'manejo' ? (
						<Form manejo />
					) : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									//Produtor
									this.props.setModoTela('cadastro', { id_safra_tipo: 1 });
									this.props.initForm({ id_safra_tipo: 1 });
								}} />
						</Grid>
						{!this.props.idArea &&
						<Select
							name='id_produtor'
							label='Produtor' 
							placeholder='Informe o produtor'
							cols='12 12 12 12'
							options={this.props.listaProdutor}
							value={this.state.id_produtor}
							onChange={data => {
								this.setState({
									...this.state,
									id_produtor: data
								})
						}} />}
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Produtor</Th>
								<Th>Talhão</Th>
								<Th>Cultura</Th>
								<Th alignRight>Área (hectare)</Th>
								<Th alignCenter>Semeadura</Th>
								<Th alignCenter>Colheita</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => {
								if (this.props.idArea) {
									return item.id_area == this.props.idArea;
								} else {
									return !this.state.id_produtor || item.id_produtor == this.state.id_produtor
								}
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome_produtor}</Td>
									<Td>{item.nome_area}</Td>
									<Td>{item.nome_especie}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.area, 2)} </Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_semeadura)}</Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_colheita)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-file-pdf'}
											visible={this.state.linhaSelecionada == item.id}
											title='Imprimir'
											event={() => {
												this.props.imprimir({ ...item });
											}} />
										<ButtonTable
											type={'success'}
											icon={'fas fa-tractor'}
											visible={this.state.linhaSelecionada == item.id}
											title='Manejo'
											event={() => {
												this.props.setModoTela('manejo', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.safra.modoTela,
	lista: state.safra.lista,
	aguardando: state.safra.aguardando,
	listaProdutor: state.safra.listaProdutor
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista, getListaProdutor, getListaArea, getListaEspecie, imprimir
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Safra);
